import React, { Component } from 'react';
import {
	Modal,
	Button,
	Alert,
	Table,
	Row,
	Col,
} from 'react-bootstrap';
import PortfolioChart from './PortfolioChart';


class PortfolioStatsModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			EPSAvg: this.props.EPSAvg,
			betaAvg: this.props.betaAvg,
			PERatioAvg: this.props.PERatioAvg,
			dividendAvg: this.props.dividendAvg,
			marketCapAvg: this.props.marketCapAvg,
			currentHoldings: this.props.currentHoldings,
			sections:this.props.sections,
			error: ''
		};

	}

	renderAlert = () => {
		if (this.state.error) {
			return (
				<Alert bsStyle="danger">
					<strong>Oops!</strong> {this.state.error}
				</Alert>
			);
		}
	}

	closeModal = () => {
		this.props.closeModal('showPortfolioStatsModal');
	}


	render() {
		return (
			<Modal show={this.props.showPortfolioStatsModal} onHide={() => this.closeModal()} id="ticker-info-modal" bsSize="large" >
				<Modal.Header closeButton>
					<Modal.Title>Portfolio Stats</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={5}>
							<Col md={12}>
								<Table>
						<thead>
						<tr>
							<th colSpan="2">Averages</th>
						</tr>
						</thead>
									<tbody>
									<tr>
										<td>EPS</td>
										<td>{this.state.EPSAvg}</td>
									</tr>
									<tr>
										<td>Beta</td>
										<td>{this.state.betaAvg}</td>
									</tr>
									<tr>
										<td>PE Ratio</td>
										<td>{this.state.PERatioAvg}</td>
									</tr>
									<tr>
										<td>Dividend</td>
										<td>{this.state.dividendAvg}</td>
									</tr>
									<tr>
										<td>Market Cap</td>
										<td>{this.state.marketCapAvg}</td>
									</tr>
									<tr>
										<td>Current Holdings</td>
										<td>{this.state.currentHoldings}</td>
									</tr>
									</tbody>
								</Table>
							</Col>
						</Col>
						<Col md={7}>
							<Col md={12}>
							<Table>
								<thead>
								<tr>
							<th colSpan="2">Sector Allocation</th>
						</tr>
						</thead>

							<PortfolioChart
								sections={this.state.sections}
								sectionsData={this.props.sectionsData}/>


					</Table>
						</Col>
						</Col>
					</Row>

				</Modal.Body>
				<Modal.Footer>
					<Button
						bsStyle="default"
						onClick={() => this.closeModal()}
					>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default PortfolioStatsModal;